import { Button, Loader } from '@mantine/core';
import { IconSparkles } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import styles from './DocumentSuggestionsBanner.module.scss';
import { Props } from './DocumentSuggestionsBanner.types';

// t('documents.suggestions.bannerPending_one', '{{count}} document peut être renommé et rangé automatiquement')
// t('documents.suggestions.bannerPending_other', '{{count}} documents peuvent être renommés et rangés automatiquement')
// t('documents.suggestions.bannerAnalyzing_one', 'Lecture de {{count}} document en cours…')
// t('documents.suggestions.bannerAnalyzing_other', 'Lecture de {{count}} documents en cours…')

const DocumentSuggestionsBanner = ({ pendingCount, analyzingCount, onOpen }: Props) => {
  const { t } = useTranslation();

  if (pendingCount === 0 && analyzingCount === 0) {
    return null;
  }

  return (
    <div className={styles.container} role="status">
      <div className={styles.text}>
        {pendingCount > 0 ? (
          <IconSparkles size={20} className={styles.icon} />
        ) : (
          <Loader size={16} />
        )}
        <span>
          {pendingCount > 0
            ? t('documents.suggestions.bannerPending', { count: pendingCount })
            : t('documents.suggestions.bannerAnalyzing', { count: analyzingCount })}
        </span>
      </div>
      {pendingCount > 0 && (
        <Button size="md" variant="light" onClick={onOpen}>
          {t('documents.suggestions.bannerButton', 'Voir les propositions')}
        </Button>
      )}
    </div>
  );
};

export default DocumentSuggestionsBanner;
